import {request} from '../lib/request';

const vehiclebrandApi = request({
  baseURL: process.env.REACT_APP_BASE_API + 'vehicle-brand/'
});

export const getVehicleBrands = async () => {
    return await vehiclebrandApi.get('list');
}